import classNames from "classnames";
import { useTranslation } from "react-i18next";

export const ChaptersButton = ({ onClick, className }) => {
  const { t } = useTranslation();

  return (
    <button
      onClick={onClick}
      className={classNames(
        "text-white border border-solid px-2 py-1 rounded-lg hover__target-unique",
        {
          [className]: className,
        }
      )}
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        minWidth: "5rem",
      }}
    >
      {t("Chapters")}
    </button>
  );
};

export const PauseButton = ({ onClick, className }) => {
  return (
    <button
      onClick={onClick}
      className={classNames("hover__wrapper", {
        [className]: className,
      })}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <g id="Gruppe_90" transform="translate(-110 -640)">
          <g
            id="Ellipse_1"
            fill="rgba(0,0,0,0.4)"
            stroke="#fff"
            className="hover__target"
            transform="translate(110 640)"
          >
            <circle cx="24" cy="24" r="24" stroke="none" />
            <circle cx="24" cy="24" r="23.5" fill="none" />
          </g>
          <g id="Pause" transform="translate(126.8 654.4)">
            <path
              id="Rechteck_8"
              d="M0 0H5.305V19.2H0z"
              fill="#fff"
              transform="translate(0 0)"
            />
            <path
              id="Rechteck_9"
              d="M0 0H5.305V19.2H0z"
              fill="#fff"
              transform="translate(9.095 0)"
            />
          </g>
        </g>
      </svg>
    </button>
  );
};

export const PlayButton = ({ onClick, className }) => {
  return (
    <button
      onClick={onClick}
      className={classNames("hover__wrapper", {
        [className]: className,
      })}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <g>
          <g
            fill="rgba(0,0,0,0.4)"
            stroke="#fff"
            className="hover__target"
            transform="translate(-110 -640) translate(110 640)"
          >
            <circle cx="24" cy="24" r="24" stroke="none" />
            <circle cx="24" cy="24" r="23.5" fill="none" />
          </g>
          <path
            fill="#fff"
            d="M601.9 2980.917l-16.9 9.917V2971z"
            transform="translate(-110 -640) translate(-457.089 -2316.917)"
          />
        </g>
      </svg>
    </button>
  );
};

export const BackButton = ({ onClick, className }) => {
  return (
    <button
      onClick={onClick}
      className={classNames("hover__wrapper", {
        [className]: className,
      })}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
      >
        <g id="Gruppe_91" transform="translate(-110 -640)">
          <g
            id="Ellipse_1"
            fill="rgba(0,0,0,0.4)"
            stroke="#fff"
            transform="translate(110 640)"
            className="hover__target"
          >
            <circle cx="18" cy="18" r="18" stroke="none" />
            <circle cx="18" cy="18" r="17.5" fill="none" />
          </g>
          <g
            id="Playback_Next"
            transform="translate(121.362 651.4)"
          >
            <path
              id="Pfad_7"
              d="M585 2977.6l11.25 6.6V2971z"
              fill="#fff"
              transform="translate(-582.975 -2971)"
            />
            <path
              id="Rechteck_7"
              d="M0 0H2.475V13.2H0z"
              fill="#fff"
              transform="translate(0)"
            />
          </g>
        </g>
      </svg>
    </button>
  );
};

export const SkipButton = ({ onClick, className }) => {
  return (
    <button
      onClick={onClick}
      className={classNames("hover__wrapper", {
        [className]: className,
      })}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Gruppe_92"
        width="36"
        height="36"
        viewBox="0 0 36 36"
      >
        <g
          id="Ellipse_1"
          fill="rgba(0,0,0,0.4)"
          stroke="#fff"
          className="hover__target"
        >
          <circle cx="18" cy="18" r="18" stroke="none" />
          <circle cx="18" cy="18" r="17.5" fill="none" />
        </g>
        <g
          id="Playback_Next"
          transform="translate(11.363 11.4)"
        >
          <path
            id="Pfad_7"
            d="M596.25 2977.6l-11.25 6.6V2971z"
            fill="#fff"
            transform="translate(-585 -2971)"
          />
          <path
            id="Rechteck_7"
            d="M0 0H2.475V13.2H0z"
            fill="#fff"
            transform="translate(10.8)"
          />
        </g>
      </svg>
    </button>
  );
};

export const SoundButton = ({ onClick, className }) => {
  return (
    <button
      onClick={onClick}
      className={classNames("hover__wrapper", {
        [className]: className,
      })}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Gruppe_92"
        width="36"
        height="36"
        viewBox="0 0 36 36"
      >
        <g
          id="Ellipse_1"
          fill="rgba(0,0,0,0.4)"
          stroke="#fff"
          className="hover__target"
        >
          <circle cx="18" cy="18" r="18" stroke="none" />
          <circle cx="18" cy="18" r="17.5" fill="none" />
        </g>
        <g
          id="Volume_-_Medium"
          transform="translate(9.6 11.369)"
        >
          <path
            id="Pfad_4"
            fill="#fff"
            d="M833.84 2745.262l-5.305-4.434H825v-4.421h3.537l5.303-4.407z"
            transform="translate(-824.998 -2732)"
          />
          <path
            id="Pfad_5"
            d="M858.342 2732.729a10.786 10.786 0 0 1 2.025 6.309 10.4 10.4 0 0 1-2.086 6.265"
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            transform="translate(-843.567 -2732.406)"
          />
          <path
            id="Pfad_6"
            d="M851.753 2736.358a8.4 8.4 0 0 1 .053 9.314"
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            transform="translate(-839.925 -2734.431)"
          />
        </g>
      </svg>
    </button>
  );
};

export const MuteButton = ({ onClick, className }) => {
  return (
    <button
      onClick={onClick}
      className={classNames("hover__wrapper", {
        [className]: className,
      })}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
      >
        <g
          fill="rgba(0,0,0,0.4)"
          stroke="#fff"
          className="hover__target"
        >
          <circle cx="18" cy="18" r="18" stroke="none" />
          <circle cx="18" cy="18" r="17.5" fill="none" />
        </g>
        <g>
          <path
            fill="#fff"
            d="M833.84 2745.262l-5.305-4.434H825v-4.421h3.537l5.303-4.407z"
            transform="translate(9.6 11.369) translate(-821.998 -2732)"
          />
        </g>
      </svg>
    </button>
  );
};

export const SubtitlesButton = ({ onClick, className }) => {
  return (
    <button
      onClick={onClick}
      className={classNames("hover__wrapper", {
        [className]: className,
      })}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
      >
        <g fill="rgba(0,0,0,.4)">
          <path
            d="M18 35.5c-4.674 0-9.069-1.82-12.374-5.126A17.385 17.385 0 0 1 .5 18c0-4.674 1.82-9.069 5.126-12.374A17.385 17.385 0 0 1 18 .5c4.674 0 9.069 1.82 12.374 5.126A17.385 17.385 0 0 1 35.5 18c0 4.674-1.82 9.069-5.126 12.374A17.385 17.385 0 0 1 18 35.5z"
            stroke="none"
          />
          <path
            d="M18 1C13.46 1 9.19 2.768 5.98 5.98A16.889 16.889 0 0 0 1 18c0 4.54 1.768 8.81 4.98 12.02C9.19 33.233 13.46 35 18 35c4.54 0 8.81-1.768 12.02-4.98C33.233 26.81 35 22.54 35 18c0-4.54-1.768-8.81-4.98-12.02A16.889 16.889 0 0 0 18 1m0-1c9.941 0 18 8.059 18 18s-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0z"
            fill="#fff"
            stroke="none"
            className="hover__target"
          />
        </g>
        <path
          d="M0 14V0h14v7a3.185 3.185 0 0 1-3.182 3.181H4.451L0 14zM10.614 3.484a1.3 1.3 0 1 0 1.3 1.3 1.3 1.3 0 0 0-1.3-1.3zm-3.469 0a1.3 1.3 0 1 0 1.3 1.3 1.3 1.3 0 0 0-1.3-1.3zm-3.47 0a1.3 1.3 0 1 0 1.3 1.3 1.3 1.3 0 0 0-1.299-1.3z"
          transform="translate(11 12)"
          fill="#fff"
        />
      </svg>
    </button>
  );
};
